import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@mui/material';
import { NotificationManager } from 'react-notifications';
import getPaymentModeService from '../../../services/getPaymentModeService';

const AddEdit = ({ open, setOpen, dialogType, editValue, setEditValue, fetchData }) => {
  const [formData, setFormData] = useState({
    bankId: '',
    bankName: '',
  });

  useEffect(() => {
    if (dialogType === 'edit' && editValue) {
      setFormData({
        bankId: editValue.bankId,
        bankName: editValue.bankName,
      });
    } else {
      setFormData({
        bankId: '',
        bankName: '',
      });
    }
  }, [dialogType, editValue]);

  const handleClose = () => {
    setOpen(false);
    setEditValue(null);
    setFormData({
      bankId: '',
      bankName: '',
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (dialogType === 'edit') {
        const response = await getPaymentModeService.UpdateBank(formData);
        if (response.success) {
          handleClose();
          fetchData();
        }
      } else {
        const response = await getPaymentModeService.AddBank(formData);
        if (response.success) {
          handleClose();
          fetchData();
        }
      }
    } catch (error) {
      console.error('Error saving bank:', error);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>{dialogType === 'edit' ? 'Edit Bank' : 'Add New Bank'}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Bank Name"
            type="text"
            fullWidth
            value={formData.bankName}
            onChange={(e) => setFormData({ ...formData, bankName: e.target.value })}
            required
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" variant="contained" color="primary">
            {dialogType === 'edit' ? 'Update' : 'Add'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddEdit; 